/* v8 ignore file */
import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { QueryClientProvider } from "@tanstack/react-query";
import HashElementScroll from "components/common/HashElementScroll";
import { queryClient } from "config/reactQueryClient";
import AlertProvider from "context/AlertContext/AlertContext";
import { BackgroundJobsProvider } from "context/BackgroundJobsContext";
import { ConfirmProvider } from "context/ConfirmationDialogContext";
import { EnvVariablesConfigProvider } from "context/EnvVariablesConfigContext";
import { LogoutProvider } from "context/LogoutContext";
import { UnsavedChangesConfirmProvider } from "context/UnsavedChangesContext";
import { useDayjsLocalization } from "hooks/useDayjsLocalization";
import useDocumentTitle from "hooks/useDocumentTitle";
import theme from "theme";
import { Loading } from "./shared";

const Accumulus = () => {
  useDocumentTitle("Accumulus");
  useDayjsLocalization();

  return (
    <Suspense fallback={<Loading />}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <HashElementScroll />
        <QueryClientProvider client={queryClient}>
          <Suspense fallback={<Loading />}>
            <BackgroundJobsProvider>
              <EnvVariablesConfigProvider>
                <ConfirmProvider>
                  <UnsavedChangesConfirmProvider>
                    <AlertProvider>
                      <LogoutProvider>
                        <Outlet />
                      </LogoutProvider>
                    </AlertProvider>
                  </UnsavedChangesConfirmProvider>
                </ConfirmProvider>
              </EnvVariablesConfigProvider>
            </BackgroundJobsProvider>
          </Suspense>
        </QueryClientProvider>
      </ThemeProvider>
    </Suspense>
  );
};

export default Accumulus;
